import {shuffle} from "../utils/arrays";
import {CUSTOM_ORDER_ASC, CUSTOM_ORDER_DESC, CUSTOM_ORDER_RANDOM} from "../stores/Modulator";

export const WAVEFORM_SIN_NAME = "sin";
export const WAVEFORM_SAW_NAME = "saw";
export const WAVEFORM_TRIANGLE_NAME = "triangle";
export const WAVEFORM_SQUARE_NAME = "square";
export const WAVEFORM_SAMPLEHOLD_NAME = "sampleHold";

const NUMBER_OF_VALUES = 360;

export interface WaveFunction { // result: -1..1
    (x: number): number;        // param x is in [degree]
}

// export interface SampleFunction { // result: -1..1
//     (x: number, samples: number[]): number;        // param x is in [degree]
// }

export interface RegenWaveFunction { // result: -1..1
    (): void;        // param x is in [degree]
}

export const identity: WaveFunction = function(x: number): number {
    return x;
}

export const invert: WaveFunction = function(x: number): number {
    return -x;
}

export const sin: WaveFunction = function(x: number): number {
    return Math.sin(x  * Math.PI / 180.0);
}

export const saw: WaveFunction = function(x: number): number {
   return x / 180.0 - 1;
   // return 1 - x / 180.0;
}

export const triangle: WaveFunction = function(x: number): number {
    if (x < 180) {
        return -1 + (2 / 180) * x;
    } else {
        return 3 - (2 / 180) * x;
    }
}

export const square: WaveFunction = function(x: number): number {
    if (x < 180) {
        return 1;
    } else {
        return -1;
    }
}

/**
 * Returns values between -1..1
 * @param segment_size
 */
export const refreshSampleHold = function(segment_size= 30): number[] {
    // console.log("refreshSampleHold");
    const values = Array(NUMBER_OF_VALUES).fill(0);
    let v = 0;
    for (let x=0; x<NUMBER_OF_VALUES; x++) {
        if ((x % segment_size) === 0) {
            v = Math.random() * 2 - 1;      // sample
        }
        values[x] = v;            // hold
    }
    return values;
    // console.log("sampleHoldValues", sampleHoldValues[1]);
}

/**
 * Returns values between 0..127
 * @param v
 */
export const buildFixedValuesWaveform = function(v: string, order: null|string = null): number[] {
    // console.log("buildFixedValuesWaveform");
    const values = Array(NUMBER_OF_VALUES).fill(0);
    if (!v || v.length === 0) return values;

    let s = v.replace(/[^0-9.]+/g, ' ')
             .replace(/\s\s+/g, ' ')
             .trim();

    let vv: number[];
    if (s.length > 0) {
        vv = s.split(' ').map(e => parseInt(e, 10));
    } else {
        return values;
    }

    // if (v.toUpperCase().includes('R')) {                        // random order
    //     vv = shuffle(vv);
    // } else if (v.toUpperCase().includes('A')) {                 // ascending order
    //     vv.sort((a, b) => a - b);
    // } else if (v.toUpperCase().includes('D')) {                 // descending order
    //     vv.sort((a, b) => b - a);
    // }

    switch (order) {
        case CUSTOM_ORDER_ASC:
            vv.sort((a, b) => a - b);
            break;
        case CUSTOM_ORDER_DESC:
            vv.sort((a, b) => b - a);
            break;
        case CUSTOM_ORDER_RANDOM:
            vv = shuffle(vv);
            break;
        default:
            break;
    }

    const step = NUMBER_OF_VALUES / vv.length;
    let i = -1;
    for (let x=0; x<NUMBER_OF_VALUES; x++) {
        if ((x % step) < 1) {
            i++;
        }
        values[x] = Math.min(vv[i], 127);
        // values[x] = vv[i] / 127 * 2 - 1;
    }
    return values;
}

type Waveforms = {
    [name: string]: {
        f: WaveFunction,
        values: undefined|number[],
        regenerate: undefined|RegenWaveFunction,
        segments: boolean,
        reverse: boolean
    }
};

export const WAVEFORMS: Waveforms = {
    [WAVEFORM_SIN_NAME] : {
        f: sin,
        values: undefined,
        regenerate: undefined,
        segments: false,
        reverse: false
    },
    [WAVEFORM_SAW_NAME] : {
        f: saw,
        values: undefined,
        regenerate: undefined,
        segments: true,
        reverse: false
    },
    [WAVEFORM_TRIANGLE_NAME] : {
        f: triangle,
        values: undefined,
        regenerate: undefined,
        segments: false,
        reverse: false
    },
    [WAVEFORM_SQUARE_NAME] : {
        f: square,
        values: undefined,
        regenerate: undefined,
        segments: true,
        reverse: false
    },
    [WAVEFORM_SAMPLEHOLD_NAME] : {
        f: x => 0,
        values: refreshSampleHold(),
        // regenerate: refreshSampleHold,
        regenerate: undefined,
        segments: true,
        reverse: false
    }
}
